<template>
    <div>
      <div class="title-text mb-3">
        <b>Resumo das informações para acionamento de Seguro</b>
      </div>
  
      <div class="white-frame">
        <div
          v-if="!loading"
          class="output-format d-xl-flex justify-content-xl-evenly py-xl-3"
        >
          <resume-global :objDTO="objDTO" />
  
          <div class="output-group">
            <div class="output-title">
              <b>Dados do Sinistro</b>
            </div>
  
            <div>
              <span>Data / Hora Sinistro:</span>
              {{ sinistroData() }}
            </div>
            <div class="output-textArea">
              <span>O que aconteceu:</span>
              {{ objDTO.Sinistro.SinistroDescricao }}
            </div>
  
            <div>
              <span>Cobertura:</span>
              {{ coverageDesc() }}
            </div>
            <div>
              <span>Evento:</span>
              {{ eventDesc() }}
            </div>
          </div>
        </div>
        <div v-if="!loading" class="col-12 Aligner aligner-right">
          <button
            class="button-base-small btn-gray font-small mx-1"
            @click="voltar"
          >
            Voltar
          </button>
          <button
            class="button-base-small btn-green font-small mx-1"
            @click="finishAviso"
             :disabled="loading"
          >
            Concluir Aviso
          </button>
        </div>
        <loading-state-f-s v-else />
      </div>
    </div>
  </template>
  
  <script>
  import dayjs from 'dayjs';
  import utc from 'dayjs/plugin/utc';
  import customParseFormat from 'dayjs/plugin/customParseFormat';
  dayjs.extend(utc);
  dayjs.extend(customParseFormat);
  import { createAviso } from '../../api/formMethods';
  import ResumeGlobal from '../ResumeGlobal.vue';
  import LoadingStateFS from '../LoadingStateFS.vue';
  import { handleAberturaResponseWithUploadDocuments } from '../../utils/helpers';
  import { AREA_NEGOCIO } from '../../utils/constants';
  
  export default {
    components: { ResumeGlobal, LoadingStateFS },
    data() {
      return {
        loading: false,
      };
    },
    props: {
      objDTO: Object,
      events: Array,
      coverages: Array,
    },
    methods: {
      getOption(value) {
        return value == 1 ? 'Sim' : 'Não';
      },
      sinistroData() {
        return dayjs(this.objDTO.Sinistro.SinistroData).format(
          'DD/MM/YYYY HH:mm'
        );
      },
      eventDesc() {
        return this.events.find(
          (x) => x.Id == this.objDTO.Sinistro.SinistroEventoId
        ).Description;
      },
      coverageDesc() {
        return this.coverages.find(
          (x) => x.GisCoverageId == this.objDTO.Apolice.ApoliceCoberturaId
        ).Description;
      },
      formatDate(date) {
        return dayjs(date)
          .local()
          .format();
      },
      async finishAviso() {
        this.loading = true;
        try{
          this.objDTO.FormAvisoId = 12;
        // this.objDTO.AreaNegocioId = 36;
        // this.objDTO.SubCategoriaId = 3600;
        this.objDTO.Sinistro.SinistroData = this.formatDate(
          this.objDTO.Sinistro.SinistroData
        );
        this.objDTO.Apolice.ApoliceDataInicio = this.formatDate(
          this.objDTO.Apolice.ApoliceDataInicio
        );
        this.objDTO.Apolice.ApoliceDataFim = this.formatDate(
          this.objDTO.Apolice.ApoliceDataFim
        );
        this.objDTO.SeguradoContacto.DataNascimento = this.formatDate(
          this.objDTO.SeguradoContacto.DataNascimento
        );
  
        const res = await createAviso(this.objDTO, this.coverages);
        // this.loading = false;
  
        handleAberturaResponseWithUploadDocuments(res, AREA_NEGOCIO.Vida);
        }
        catch(e){
          console.log(e);
        }
        finally{
          this.loading = false;
        }
      },
      voltar() {
        this.$emit('back', 1);
      },
    },
    computed: {},
  };
  </script>
  